import { RouteObject } from "react-router-dom";

const LoginRoutes: RouteObject[] = [
    // placeholder for login routes
];

export default LoginRoutes;
